import { gql } from '@apollo/client';

export const UPDATE_PATIENT = gql`
  mutation updatePatient($data: UpdatePatientInput!) {
    updatePatient(data: $data) {
      id
    }
  }
`;
